import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-under-construction',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="under-construction">
      <mat-icon class="construction-icon">engineering</mat-icon>
      <h1>Under Construction</h1>
      <p>We're working to enable this feature. Please check back later!</p>
    </div>
  `,
  styles: `
    .under-construction {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 400px;
      text-align: center;
      padding: 48px 24px;
    }

    .construction-icon {
      font-size: 64px;
      width: 64px;
      height: 64px;
      color: #f59e0b;
      margin-bottom: 16px;
    }

    h1 {
      font-size: 1.5rem;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 8px 0;
    }

    p {
      font-size: 1rem;
      color: #64748b;
      margin: 0;
      max-width: 400px;
      line-height: 1.5;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnderConstructionComponent {

}
